import React from 'react'
import PropTypes from 'prop-types'
import { Nav } from 'react-bootstrap'

class PageNavUnstyled extends React.Component {
  activeHref = () => this.props.history.location.pathname

  render = ({ children } = this.props) => {
    const activeHref = this.activeHref()
    let activeKey = null
    const childrenWithProps = React.Children.map(
      children,
      (child, eventKey) => {
        if (child) {
          if (activeHref.includes(child.props.href)) {
            activeKey = eventKey
          }

          return React.cloneElement(child, {
            activeHref,
            eventKey,
            history: this.props.history,
          })
        }
        return null
      },
    )

    return (
      <Nav
        activeKey={activeKey}
        activeHref={activeHref}
        bsStyle="tabs"
        className={this.props.className}
      >
        {childrenWithProps}
      </Nav>
    )
  }
}

PageNavUnstyled.propTypes = {
  history: PropTypes.object.isRequired,
}

export { PageNavUnstyled }
